/* global BigInt:readonly */

const exactText = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const text = typeof value === 'number' ? (Number.isFinite(value) ? value.toFixed(4) : '') : String(value);
  return /^-?\d+(?:\.\d{1,4})?$/.test(text) ? text : null;
};

export const formatRecognizedRevenueAmount = (value) => {
  const text = exactText(value);
  if (text === null) return '—';
  const negative = text.startsWith('-');
  const [whole, fraction = ''] = text.replace(/^-/, '').split('.');
  const decimals = fraction.replace(/0+$/, '');
  const grouped = whole.replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${negative && /[1-9]/.test(whole + fraction) ? '-' : ''}${grouped}${decimals ? `,${decimals}` : ''}`;
};

export const sumRecognizedRevenueAmounts = (values = []) => {
  let total = 0n;
  for (const value of values) {
    const text = exactText(value);
    if (text === null) return null;
    const [whole, fraction = ''] = text.replace(/^-/, '').split('.');
    total += (BigInt(whole) * 10000n + BigInt(fraction.padEnd(4, '0'))) * (text.startsWith('-') ? -1n : 1n);
  }
  const absolute = total < 0n ? -total : total;
  return `${total < 0n ? '-' : ''}${absolute / 10000n}.${String(absolute % 10000n).padStart(4, '0')}`;
};
